<template>
  <v-snackbar
    v-model="snackbarVisible"
    top
    :color="snackbar.color"
  >
    {{ snackbar.text }}
    <template v-slot:action="{ attrs }">
      <v-btn
        dark
        outlined
        small
        text
        v-bind="attrs"
        @click="snackbarVisible = false"
      >
        <v-icon small>
          fa fa-times
        </v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: 'Alert',
  computed: {
    snackbar() {
      return this.$store.getters[this.$storeGetters.ALERT]
    },
    snackbarVisible: {
      get: function () {
        return this.$store.getters[this.$storeGetters.ALERT_VISIBLE]
      },
      set: function (value) {
        this.$store.dispatch(this.$storeActions.ALERT_TOGGLE_VISIBLE, value)
      }
    }
  }
}
</script>
